import i18next from 'i18next';
import { format, parseISO } from 'date-fns';

import { TranslationNamespaces } from '../../../locales/constants/translationNamespaces.enum';

export const convertDateFormat = (
  originalDate: string | undefined,
  includeTime = false
): string => {
  if (!originalDate) return '';

  const targetDate = parseISO(originalDate);

  if (isNaN(targetDate.getTime())) {
    return originalDate;
  }

  return includeTime ? format(targetDate, 'dd/MM/yyyy HH:mm') : format(targetDate, 'dd/MM/yyyy');
};

export const capitalizeFirstLetter = (status: string): string => {
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};

const selectAll = i18next.t('OrderList.all', {
  ns: TranslationNamespaces.SITE_STATUS
});

export const formatListForVerticalityFormSelect = (list: string[]) => {
  const allOption = { value: selectAll, label: selectAll };

  return [allOption, ...list.map((item) => ({ value: item, label: item }))];
};
